var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSciences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10.68 13.33a12.5 12.5 0 0 1 5.63-4.88A12 12 0 0 1 27 9.91a22.5 22.5 0 0 1 7.24 8.43c1.85 3.43 3.22 7.33 2.6 11.17s-3.73 7.48-7.63 7.6c-3 .08-5.86-2-7.32-4.66-1.24-2.29-1.78-5.16-3.92-6.66C15.45 24 11.69 24 9.7 21.24c-1.7-2.3-.43-5.77.98-7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M34.76 34.79a3.36 3.36 0 0 1 .92 3.44 5.8 5.8 0 0 1-2.21 3A9.3 9.3 0 0 1 27.6 43c-2.88-.1-5.77-1.55-8.53-.72M8.83 7.88c.44.407.939.744 1.48 1A6.1 6.1 0 0 1 12.36 11M24.55 5l-.14 3.33M34 16.92c.873-.633 1.8-1.189 2.77-1.66M37.21 29.1a9.4 9.4 0 0 1 3.32.66M22 33.2l-3.17 1.89M9.66 21.31A6.44 6.44 0 0 0 7 24.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7900",
    d: "M20.84 18.25a6.62 6.62 0 0 0 3.43 4 2.82 2.82 0 0 0 2.17.28 2.51 2.51 0 0 0 1.37-2.11A5 5 0 0 0 26 15.77c-2.38-1.83-6.1-.77-5.16 2.48M30 30.22a1.6 1.6 0 0 0 .39 1.27 1.35 1.35 0 0 0 1.25.29 2.47 2.47 0 0 0 1.14-.68 3 3 0 0 0 .93-1.76 1.81 1.81 0 0 0-.8-1.74c-1.53-.89-2.85 1.4-2.91 2.62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 4h35.53v40.03H6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSciences);
export default __webpack_public_path__ + "static/media/sciences.e0974e1e5007399c1ca09e8d02aaa4cc.svg";
export { ForwardRef as ReactComponent };